<script>
import Certification from "../components/Certification.vue";
export default {
  components: { Certification },
  name: "Streamer-info",
  props: {
    infosData: {},
  },
};
</script>

<template>
  <div class="streamer-info">
    <img
      v-show="infosData.image"
      :src="infosData.image"
      :alt="`Avatar do streamer {{ infosData.streamerNickName }}`"
      fetchpriority="high"
      rel="preload"
    />
    <h2>
      {{ infosData.username }} <Certification v-show="infosData.isVerified" />
    </h2>
    <!-- <div class="social-content">
            <a v-if="infosData.twitterLink" 
                :href="infosData.twitterLink" 
                class="social-links" 
                id="twitter-icon"
                target="_blank"
            ></a>
            <a v-if="infosData.instagramLink" 
                :href="infosData.instagramLink" 
                class="social-links" 
                id="instagram-icon"
                target="_blank"
            ></a>
            <a v-if="infosData.twitchLink" 
                :href="infosData.twitchLink" 
                class="social-links" 
                id="twitch-icon"
                target="_blank"
            ></a>
            <a v-if="infosData.youtubeLink" 
                :href="infosData.youtubeLink" 
                class="social-links" 
                id="youtube-icon"
                target="_blank"
            ></a>
        </div> -->
  </div>
</template>

<style scoped>
.streamer-info {
  overflow: hidden;
  border-radius: 0px var(--border-simple) var(--border-simple)
    var(--border-simple);
  width: 100%;
  min-height: 65px;
  max-width: 420px;
  margin: auto;
  background-color: var(--white);
  border-radius: var(--border-simple);
  box-shadow: var(--form-shadow);
  display: flex;
  align-items: center;
}

.streamer-info img {
  display: block;
  width: 65px;
  height: 65px;
  object-fit: cover;
  border-radius: 0px var(--border-simple) var(--border-simple) 0px;
  object-position: center center;
}

.streamer-info h2 {
  font-weight: 700;
  font-family: var(--montserrat);
  font-size: 25px;
  letter-spacing: 1px;
  color: var(--black);
  margin-left: 16px;
  display: flex;
  align-items: center;
  gap: 0.2rem;
}

.streamer-info .social-content {
  display: flex;
  gap: 6px;
  margin: 0px 22px 0px auto;
  align-items: center;
}

.streamer-info .social-content a {
  width: 20px;
  height: 20px;
  display: block;
}
</style>